export type PopulationFilters = Record<string, Record<string, boolean>>;

export const togglePopulationFilter = (
  current: PopulationFilters | null | undefined,
  questionId: string,
  code: string | string[],
): PopulationFilters => {
  const codes = Array.isArray(code) ? code : [code];
  const filters = { ...current };
  const questionFilters = { ...(filters[questionId] || {}) };
  if (codes.every((item) => questionFilters[item])) {
    codes.forEach((item) => delete questionFilters[item]);
    if (Object.keys(questionFilters).length === 0) delete filters[questionId];
    else filters[questionId] = questionFilters;
  } else {
    codes.forEach((item) => (questionFilters[item] = true));
    filters[questionId] = questionFilters;
  }
  return filters;
};
